import api from '@/api'

export default {
  all: (filter) => api('get', '/workflow', filter),
  create: (data) => api('post', '/workflow', data),
  show: (id) => api('get', `/workflow/${id}`),
  delete: (id) => api('delete', `/workflow/${id}`),
  update: (data) => api('put', `/workflow/${data.id}`, data),
  showUsers: (id) => api('get', `/workflow/${id}/users`),
}